module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-panel"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('notes', {
    attrs: {
      "canAdd": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "panel pax"
  }, [_c('h5', {
    staticClass: "d-flex"
  }, [_c('div', [_vm._v("Check-in")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto fs-small bold"
  }, [_vm._v("Total: " + _vm._s(_vm.paxTotal))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('span', {
    staticClass: "mr-auto"
  }, [_vm._v("Check-in")]), _vm._v(" "), _c('calculator', {
    attrs: {
      "object": _vm.reservation,
      "field": "paxCheckedIn",
      "max": _vm.reservation.paxTotal
    },
    on: {
      "mathDone": _vm.mathDone
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('span', {
    staticClass: "mr-auto"
  }, [_vm._v("No-show")]), _vm._v(" "), _c('calculator', {
    attrs: {
      "object": _vm.reservation,
      "field": "paxNoShow",
      "max": _vm.reservation.paxTotal
    },
    on: {
      "mathDone": _vm.mathDone
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "d-flex ml-auto btn wide",
    on: {
      "click": _vm.checkAll
    }
  }, [_vm._v("Check All")])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4918e194", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4918e194"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/view/ViewOverview.vue
// module id = 2023
// module chunks = 0